import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogTitle,
} from "../alert-dialog";
import { Button } from "../button";
import { LucideCheck } from "lucide-react";
const Icon = () => (
  <div className="bg-green-200 rounded-full">
    <LucideCheck color="green" className="h-9 w-9 text-destructive m-2 flex-shrink-0"/>
  </div>
);

type SuccessDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description?: string
}

const SuccessDialog = ({ open, onOpenChange, title, description } : SuccessDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogOverlay className="z-40 bg-black/50" />

      <AlertDialogContent className="z-50">
        <AlertDialogHeader className="flex items-center gap-2">
          <Icon />
          <AlertDialogTitle className="font-bold text-xl">
            {
              title || "Success"
            }
          </AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
            {description || ""}
        </AlertDialogDescription>
        <AlertDialogFooter className="flex sm:justify-center sm:mt-3">
          <AlertDialogCancel>Ok</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SuccessDialog;
